import angular from 'angular';

// NOTE: please try to convert a service to a non-Angular dependent service instead of using this
// to help the project progress in the React migration and avoid Angular dependencies down the line.
export default <T>(serviceName: string): T => {
  const injector = angular.element(document.body).injector();
  return injector && injector.get(serviceName);
};
